/**
 * TimeScaleSelector Component
 *
 * Allows selection of time periods for chart data filtering.
 * Options: 24h, 7d, 30d, 90d
 */

import { Clock } from 'lucide-react';

const TIME_SCALES = [
  { value: '24h', label: '24h' },
  { value: '7d', label: '7 Tage' },
  { value: '30d', label: '30 Tage' },
  { value: '90d', label: '90 Tage' },
];

export default function TimeScaleSelector({ value = '7d', onChange }) {
  return (
    <div className="flex items-center gap-2">
      <Clock className="w-4 h-4 text-gray-500" />
      <div className="flex rounded-lg bg-gray-800 p-1">
        {TIME_SCALES.map((scale) => (
          <button
            key={scale.value}
            type="button"
            onClick={() => onChange(scale.value)}
            className={`px-3 py-1 rounded text-sm transition-colors ${
              value === scale.value
                ? 'bg-emerald-600 text-white'
                : 'text-gray-400 hover:text-white hover:bg-gray-700'
            }`}
          >
            {scale.label}
          </button>
        ))}
      </div>
    </div>
  );
}
